/* @ts-ignore */
import * as React from 'react';
import { Form, Input, AutoComplete, Select, Upload, Icon, Divider } from 'antd';
import { Button } from '@ui/components';
import { transformFormatSource } from '@ui/tools/transformSource';

import './CreateStoreForm.less';
import { OptionProps } from 'antd/lib/select';

const { Item } = Form;
let idCity = 0;

export default Form.create({
  name: 'form_in_modal',
  onValuesChange: (props: any, changedValues: any) => {
    if ('city' in changedValues) {
      idCity = Number.parseInt(changedValues.city, 10);
      props.form.setFieldsValue({
        market: '',
      });
    }
    props.onFieldsChange(changedValues);
  },
})(
  // @ts-ignore
  class extends React.Component {
    get dataSource() {
      // @ts-ignore
      return transformFormatSource(this.props.cities);
    }

    get factoriesSource() {
      // @ts-ignore
      return transformFormatSource(this.props.factories);
    }

    get marketsSource() {
      if (idCity) {
        // @ts-ignore
        return transformFormatSource(this.props.markets.filter((market) => market.city.id === idCity));
      }

      // @ts-ignore
      return transformFormatSource(this.props.markets);
    }

    get collectionsSource() {
      // @ts-ignore
      return transformFormatSource(this.props.collections);
    }

    private filterOption = (input: string, option: React.ReactElement<OptionProps>) => {
      if (option.props.children && typeof option.props.children === 'string') {
        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }
      return false;
    };

    private handleSelectCollections = (value: string[]) => {
      if (value.includes('all')) {
        return this.collectionsSource.map((c) => c.value);
      }
      return value;
    };

    render() {
      const {
        // @ts-ignore
        onCreate,
        // @ts-ignore
        form: { getFieldDecorator },
        // @ts-ignore
        file,
      } = this.props;

      return (
        <Form className="create-store-form__form">
          <Item
            label="IdLotus"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            {getFieldDecorator('idLotus')(<Input size="large" className="input-id-lotus" />)}
          </Item>

          <Item label="Название">
            {getFieldDecorator('name', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
            })(<Input size="large" />)}
          </Item>

          <Item label="Город">
            {getFieldDecorator('city', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
            })(<AutoComplete dataSource={this.dataSource} size="large" />)}
          </Item>

          <Item label="ТЦ">
            {getFieldDecorator('market')(
              <Select size="large">
                {this.marketsSource.map((d: any) => (
                  <Select.Option key={d.value}>{d.text}</Select.Option>
                ))}
              </Select>,
            )}
          </Item>

          <Item label="Адрес">
            {getFieldDecorator('address', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
            })(<Input size="large" />)}
          </Item>

          <Item label="Фабрики">
            {getFieldDecorator('factories')(
              <Select showSearch mode="multiple" size="large" filterOption={this.filterOption}>
                {this.factoriesSource.map((d: any) => (
                  <Select.Option key={d.value}>{d.text}</Select.Option>
                ))}
              </Select>,
            )}
          </Item>

          <Item label="Телефон">
            {getFieldDecorator('phone', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
            })(<Input size="large" />)}
          </Item>

          <Item label="Mail">
            {getFieldDecorator('mail', {
              rules: [{ type: 'email', message: 'Не валидный e-mail' }],
            })(<Input size="large" />)}
          </Item>

          <Item>
            {getFieldDecorator('file')(
              <Upload beforeUpload={() => false} name={'photo-store'} fileList={file ? [file.file] : []}>
                <div style={{ paddingTop: '16px' }}>
                  <Button type="primary" size="large" className="upload-store-photo">
                    <Icon type="camera" /> загрузить фото
                  </Button>
                </div>
              </Upload>,
            )}
          </Item>

          <Divider orientation="left">
            <span className="create-store-divider">Коллекции</span>
          </Divider>

          <Item label="Эталон">
            {getFieldDecorator('collections', {
              rules: [{ required: true, message: 'вы должны заполнить поле' }],
              getValueFromEvent: this.handleSelectCollections,
            })(
              <Select mode="multiple" size="large" onChange={this.handleSelectCollections}>
                <Select.Option key="all" value="all">
                  Выбрать все
                </Select.Option>
                {this.collectionsSource.map((d: any) => (
                  <Select.Option key={d.value}>{d.text}</Select.Option>
                ))}
              </Select>,
            )}
          </Item>

          <Divider orientation="left">
            <span className="create-store-divider">Контактное лицо</span>
          </Divider>

          <Item>
            <Item label="Имя" style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
              {getFieldDecorator('firstName')(<Input size="large" />)}
            </Item>

            <Item
              label="Отчество"
              style={{
                display: 'inline-block',
                width: 'calc(50% - 12px)',
                marginLeft: '24px',
              }}
            >
              {getFieldDecorator('middleName')(<Input size="large" />)}
            </Item>
          </Item>

          <Item label="Фамилия">{getFieldDecorator('lastName')(<Input size="large" />)}</Item>

          <Item label="Телефон">{getFieldDecorator('firstContactPhone')(<Input size="large" />)}</Item>

          <Item style={{ paddingTop: '8px' }}>{getFieldDecorator('secondContactPhone')(<Input size="large" />)}</Item>

          <Item style={{ paddingTop: '32px' }}>
            <Button onClick={onCreate} htmlType="submit" className="button-create-store">
              Создать
            </Button>
          </Item>
        </Form>
      );
    }
  },
);



// WEBPACK FOOTER //
// ./src/scenes/CreateStore/components/CreateStoreForm/CreateStoreForm.tsx